import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'

class ContactDetails extends React.Component {
  state = {
    user_name: '',
    user_email: '',
    user_message: '',
    isData: false,
  }

  componentDidMount() {
    this.getConstant()
  }
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }
  getConstant = async () => {
    await axios
      .get(Constant.getAPI() + `/user/list-contact-us`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.match.params.id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  addContactUS = () => {
    var data = {
      user_id: this.props.match.params.id,
      user_name: this.state.user_name,
      user_email: this.state.user_email,
      user_message: this.state.user_message,
    }
    this.setState({ isData: true })

    axios
      .post(Constant.getAPI() + '/user/contact-us', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'ContactUs Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = '#/contact-us'
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  onSaveData = () => {
    var that = this
    that.setState({ isSaving: true })

    that.addContactUS()
  }
  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Edit Contact Details</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Edit Contact Details</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="">
                      {this.state.isloading ? (
                        'Loading ..!'
                      ) : (
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">User name</label>
                                <div className="col-sm-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="user_name"
                                    id="user_name"
                                    placeholder="User Name"
                                    onChange={this.handleChange}
                                    value={this.state.user_name}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">User Email</label>
                                <div className="col-sm-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="user_email"
                                    id="user_email"
                                    placeholder="email"
                                    onChange={this.handleChange}
                                    value={this.state.user_email}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-sm-3 col-form-label">User Message</label>
                                <div className="col-sm-9">
                                  <textarea
                                    type="text"
                                    className="form-control"
                                    name="user_message"
                                    id="user_message"
                                    placeholder="message"
                                    onChange={this.handleChange}
                                    value={this.state.user_message}
                                    row={3}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row float-right p-3">
                            {this.state.isData ? (
                              <button
                                className="btn btn-grd-disabled mr-2"
                                disabled
                              >
                                Saving...!
                              </button>
                            ) : (
                              <button
                                onClick={this.onSaveData}
                                className="btn btn-grd-disabled mr-2"
                              >
                                <i className="icofont icofont-save"></i> Save
                              </button>
                            )}
                            <Link
                              to={'/languages'}
                              className="btn btn-outline-dark"
                            >
                              Cancel
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ContactDetails
